import { trackNavigationHeaderClick } from '../../../../../../shared';
import type { VisualItem, VisualLayout } from '../../../../../../types';
import { BrandCard, FeatureCard, ServiceCard } from '../../../../shared';
import './visual-items-grid.scss';

type VisualItemsGridProps = {
    items: VisualItem[];
    layout: VisualLayout;
    selectionPath: string[];
};

export function VisualItemsGrid({ items, layout, selectionPath }: Readonly<VisualItemsGridProps>) {
    function trackItemClick(item: VisualItem) {
        trackNavigationHeaderClick({
            selection: [...selectionPath, item.title ?? item.label],
            linkUrl: item.href,
            navSection: 'main nav',
        });
    }

    return (
        <ul aria-label="Navigation links" className="visual-items-grid" data-layout={layout}>
            {items.map(item => (
                <li key={`${item.href}::${item.title ?? item.label}`} className="visual-items-grid__item">
                    {layout === 'imageOnly' && (
                        <BrandCard
                            card={{
                                href: item.href,
                                imageUrl: item.imageUrl,
                                label: item.label,
                                openInNewTab: item.openInNewTab,
                            }}
                            onClick={() => trackItemClick(item)}
                        />
                    )}
                    {layout === 'imageWithTitle' && (
                        <ServiceCard
                            card={{
                                href: item.href,
                                imageUrl: item.imageUrl,
                                title: item.title ?? item.label,
                                openInNewTab: item.openInNewTab,
                            }}
                            onClick={() => trackItemClick(item)}
                        />
                    )}
                    {layout === 'imageWithTitleAndDescription' && (
                        <FeatureCard
                            card={{
                                description: item.description,
                                href: item.href,
                                imageUrl: item.imageUrl,
                                openInNewTab: item.openInNewTab,
                                title: item.title ?? item.label,
                            }}
                            onClick={() => trackItemClick(item)}
                        />
                    )}
                </li>
            ))}
        </ul>
    );
}
